import React, { Component } from 'react';
import TableData from '../component/TableData.js'; //table row component
import TableHead from '../component/TableHead.js'; //component used for headers of table columns
import Submit from '../component/Submit.js';
import Input from '../component/Input.js';
import SelectBox from '../component/Select.js';
import Validation from './Validation.js';

export default class ShoppingCart extends Component{
	constructor(props){
		super(props);
		this.handleRemove = this.handleRemove.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleOrder = this.handleOrder.bind(this);
		this.state = {enough:true};
	}

	handleRemove(item){ //method that handles removing item from cart
		this.props.remove(item);
	}

	handleChange(id,newQuant){ //method that handles a quantity change for a specific line item
		this.props.quantChange(id,newQuant);
	}

	handleOrder(){ //method for handling an order, sets order submit in motion in prizeshop/gift shop
		if(this.props.total <= this.props.limit){ //checks to make sure user has enough points/budget before setting order in motion
			this.setState({enough:true});
			this.props.order();
		}else{
			this.setState({enough:false});
		}
	}

	render(){
		let totalColor;
		let tableHeads;
		let notes;
		let total = this.props.total;
		const inputStyle = "pa2 br2 h2 bw1 w-100-ns w-100 shadow-3";
		const areaStyle = "pa2 br2 bw1 w-100-ns w-100 shadow-3";
		const selectStyle = "w-100 h2 shadow-2 pa1 br2 b--gray bw1";
		let dollarSign;
		if(this.props.app === "lov"){
			tableHeads = ["Prize","Size","Color","Quantity","Price","Remove"];
		}else{ //asm shopping cart contains call center and additional notes while lov shopping cart does not
			total = total.toFixed(2);
			dollarSign = "$";
			tableHeads = ["Gift","Size","Color","Quantity","Price","Remove"];
			notes = <div className="fl w-100 mv3">
								<div className="w-100" style={{maxWidth:'520px',margin:'auto'}}>
									<div className="pb3 pt1">
										<div className="fl w-100 pa1">
											<div>
												<label className="b">Street Address:<span className="b red f4">*</span><span className="red" id="street_address_span"></span></label>
											</div>
											<div>
												<Input type="text" id="street_address" identity="street_address" onInput={this.props.notes} inputStyle={inputStyle}/>
											</div>
										</div>
										<div className="pt4 pb4">
											<div className="fl w-50 pa1">
												<div>
													<label className="b">City:<span className="b red f4">*</span><span className="red" id="city_span"></span></label>
												</div>
												<div>
													<Input type="text" id="city" identity="city" onInput={this.props.notes} inputStyle={inputStyle}/>
												</div>
											</div>
											<div className="fl w-20 pa1">
												<div>
													<label className="b">State:<span className="b red f4">*</span></label>
												</div>
												<div>
													<SelectBox name="state" id="state" identity="state" onSelect={this.props.notes} options={this.props.states} styles={selectStyle}/>
												</div>
											</div>
											<div className="fl w-30 pa1">
												<div>
													<label className="b">Zip:<span className="b red f4">*</span><span className="red" id="zipcode_span"></span></label>
												</div>
												<div>
													<Input type="text" id="zipcode" identity="zipcode" onInput={this.props.notes} inputStyle={inputStyle}/>
												</div>
											</div>
										</div>
									</div>
									<div className="fl w-100 pa1 pb2">
										<div>
											<label className="b">Shipping Instructions:<span className="red" id="shipping_instructions_span"></span></label>
										</div>
										<div>
											<Input type="area" identity="shipping_instructions" id="shipping_instructions" onInput={this.props.notes} styles={areaStyle}/>
										</div>
									</div>
 									<div className="fl w-100 pa1">
										<div>
											<label className="b">Event Description: <span className="b red f4">*</span><span className="red" id="notes_span"></span></label>
										</div>
										<div>
											<Input type="area" identity="notes" id="notes" onInput={this.props.notes} styles={areaStyle}/>
										</div>
									</div>
								</div>
							</div>;
		}
		let items = this.props.items;
		let itemquant;
		let columns;
		const cart = items.map((item,i)=>{
			if(this.props.app === 'lov'){
				columns = item;
			}else{ //for asm, need to track item inventory level for each item
				columns = {prize:item.prize,size:item.size,color:item.color,quantity:item.quantity,total:item.total};
				itemquant = item.totalAvailable;
			}
			return( //returns a table row for each line item
				<TableData key={i} id={i} columns={columns} app={this.props.app} itemqty={itemquant} type="cart" remove={this.handleRemove} change={this.handleChange} cellstyle="tc bb pt2 pb2 b--silver"/>
		)});
		let orderButton;
		if(total > 0){ //only display order button if there are items in the cart
			orderButton = <div className="fl w-100 mt3"><Submit name="Order" onClick={this.handleOrder} styles="bg-dark-blue white b br3 h2 w-20 mt2"/></div>;
			if(this.props.limit < this.props.total){
				totalColor = "red";
			}
		}
		let prompt;
		if(!this.state.enough){
			prompt = this.props.app === "lov"?"*Not enough points.":"*Not enough in budget";
		}
		return(
			<div>
				<div className="fl w-40">
					<h2 className="blue">Shopping Cart</h2>
				</div>
				<div className="fl w-30 tc">
					<p className="red b">{prompt}</p>
				</div>
				<div className="fl w-30">
					<p className="tr"><span className="b mid-gray">Total: </span>{dollarSign}<span className={totalColor}>{total}</span></p>
				</div>
					<table className="fl w-100 collapse">
						<thead className="collapse">
							<TableHead columns={tableHeads} headstyle="bb pt1 pb1 f4 b--silver mid-gray"/>
						</thead>
						<tbody>
							{cart}
						</tbody>
					</table>
				{notes}
				<div className="mt3">
					{orderButton}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ShoppingCart.js